import React from "react";

import TestEditor from "./test_editor";

import {TestId, Test, TestResult} from "common/flowmaster/types/test";
import {LlmRunId, LlmRunTestResults} from "common/flowmaster/types/llm_run";
import {OrganisationId} from "common/types/organisation";

interface TestProps {
  llmRunId: LlmRunId;
  organisationId: OrganisationId;
  tests: Test[];
  results?: LlmRunTestResults[];
  onAddTest: () => void;
  onUpdateTest: (
    id: TestId,
    type: string,
    value: Record<string, unknown>,
  ) => void;
  onDeleteTest: (id: TestId) => void;
}

export default function Tests({
  llmRunId,
  organisationId,
  tests,
  results,
  onUpdateTest,
  onDeleteTest,
}: TestProps) {
  return (
    <div style={{margin: "1em 0"}}>
      {tests.map(test => (
        <TestEditor
          key={test.workflow_test_id}
          llmRunId={llmRunId}
          organisationId={organisationId}
          test={test}
          results={(results ?? ([] as TestResult[]))
            .map(result =>
              result.results.find(
                resultItem =>
                  resultItem.workflow_test_id === test.workflow_test_id,
              ),
            )
            .filter(item => item)}
          onUpdate={(type: string, value: Record<string, unknown>) =>
            onUpdateTest(test.workflow_test_id, type, value)
          }
          onDelete={() => onDeleteTest(test.workflow_test_id)}
        />
      ))}
    </div>
  );
}
